import { Route, Routes } from 'react-router-dom';
import { BrandsPage } from './BrandsPage';
import { ModifyBrandPage } from './ModifyBrandPage';

export const BrandPageRoot = () => (
  <Routes>
    <Route path='/new' element={<ModifyBrandPage />} />
    <Route path='/:brandID' element={<ModifyBrandPage />} />
    <Route path='*' element={<BrandsPage />} />
  </Routes>
);
